exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Global */\n/* MOBILE */\n/* Modal */\n/* Header - Navbar */\n/* Footer */\n.Footer_Footer__37hEc {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 2.5rem;\n  color: #FFF;\n  display: grid;\n  align-items: center;\n  justify-items: center; }\n", ""]);

// Exports
exports.locals = {
	"Footer": "Footer_Footer__37hEc"
};